module.exports = __webpack_public_path__ + "img/arach_apostelbilder.416a7d0a.jpg";